<template>
  <div id="app">
    <div id="container">
      <router-view />
    </div>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {

  },
  data() {
    return {}
  }
}
</script>

<style lang="less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  background-color: #00010a;
}

#container {

  width: 100%;
  margin: auto;

}
</style>
